import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  LinearProgress,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import BASEURL from "../../../Utils/Baseurl";
import UserDetailsContext from "../../../../context/auth";
import MaterialSelect from "../../../../components/MasterSelect";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";
import Swal from "sweetalert2";
const AddRegularization = () => {
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const { user, AccessData } = useContext(UserDetailsContext);

  // Check if current user is HR/Admin
  const isAdmin = AccessData && Array.isArray(AccessData) && AccessData.some(
    (item) => (item.component === "HrApproval" || item.component === "EditRegularaization") && item.can_access
  );

  // Employee selector for admin on-behalf flow
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [regularizationData, setRegularizationData] = useState({
    requestedDate: new Date().toISOString().split("T")[0],
    checkIn: "",
    checkOut: "",
    reason: "",
    checkInStatus: "unchecked",
    checkOutStatus: "unchecked",
    reasonStatus: "unchecked",
  });

  

  const [originalRegularizationData, setOriginalRegularizationData] = useState({
    checkIn: "",
    checkOut: "",
    reason: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  // Fetch employees for admin on-behalf selector (same branch)
  useEffect(() => {
    if (isAdmin) {
      const fetchEmployees = async () => {
        try {
          const _parsedUser = JSON.parse(sessionStorage.getItem("user"));
          const loggedInUser = Array.isArray(_parsedUser) ? _parsedUser[0] : _parsedUser;
          const query = `query($branches: [String]) { allUsersDetail(branches: $branches) { id firstName lastName empid category } }`;
          const response = await axios.post(BASEURL, {
            query,
            variables: { branches: loggedInUser?.branch ? [loggedInUser.branch] : [] },
          }, { headers: { "Content-Type": "application/json" } });
          const users = response.data?.data?.allUsersDetail || [];
          const options = users.map((u) => ({
            value: u.id,
            label: `${u.firstName} ${u.lastName} (${u.empid})`,
          }));
          setEmployeeOptions(options);
        } catch (error) {
        }
      };
      fetchEmployees();
    }
  }, [isAdmin]);

  const onRegularizationSubmit = async () => {
    const query = `
          mutation regularizationApprovalHR($input: CreateRegularizationInput!) {
            regularizationApprovalHR(input: $input) {
              regularizationApproval {
                id
                checkIn
                checkOut
                reason
                teamleaderId
              }
            }
          }
        `;

    const { checkIn, checkOut, reason } = regularizationData;
    const encodedId = btoa(user?.id);

    // Determine userId - use selected employee for admin on-behalf
    let targetUserId;
    let autoApprove = false;
    if (isAdmin && selectedEmployee) {
      const selectedEncrypted = btoa(selectedEmployee.value);
      targetUserId = "VXNlck5vZGU6" + "" + selectedEncrypted;
      autoApprove = true;
    } else {
      targetUserId = "VXNlck5vZGU6" + "" + encodedId;
    }

    let resultttt = {
      userId: targetUserId,
      checkIn: checkIn,
      checkOut: checkOut,
      reason: reason,
      teamleaderId: user?.teamleader,
      autoApprove: autoApprove,
    }



    try {

      const response = await fetch(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query,
          variables: {
            input: {
              userId: targetUserId,
              checkIn: checkIn,
              checkOut: checkOut,
              reason: reason,
              teamleaderId: user?.teamleader,
              autoApprove: autoApprove,
            },
          },
        }),
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok || data.errors) {
        throw new Error(data.errors?.[0]?.message || "Something went wrong");
      }


      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //   ...snackBar,
      //   Success: true,
      // });

      if (data) {

        navigate("/regularization-request");
        Swal.fire({
          position: "center",
          icon: "success",
          title: isAdmin && selectedEmployee
            ? `Regularization approved for ${selectedEmployee.label}`
            : "Regularization Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEditRegularizationSubmit = async () => {
    setPageState({
      ...pageState,
      state: "submitting",
    });

    const query = `
          mutation updateRegularizationApproval($input: RegularizationApprovalUpdateInput!) {
            updateRegularizationApproval(input: $input) {
              regularizationApproval {
                id
                checkIn
                checkOut
                reason
                teamleaderId
              }
            }
          }
        `;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            input: {
              id: id,
              checkIn: regularizationData.checkIn,
              checkOut: regularizationData.checkOut,
              reason: regularizationData.reason,
              teamleaderId: regularizationData.teamleaderId,
            },
          },
        }),
      });

      const responseData =
        response.data.data.updateRegularizationApproval.regularizationApproval;

      // Check if there's an error in the response data
      if (responseData.errors) {
        throw new Error(
          responseData.errors[0]?.message || "Something went wrong"
        );
      }


      if (responseData) {
        navigate("/regularization-request");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Regularization Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteRegularization();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteRegularization = async () => {
    const query = `
            mutation deleteRegularizationApproval($id: ID!) {
                deleteRegularizationApproval(id: $id) {
                    success
                }
            }
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      const responseData = response.data;

      // Ensure that the success flag is checked correctly
      if (responseData.data.deleteRegularizationApproval.success) {
        navigate("/regularization-request");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Regularization deleted successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
      }
    } catch (error) {
      console.error(
        "An error occurred while deleting the Regularization:",
        error
      );
    }
  };

  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `query get_regularization($id:String){
               getRegularizationById(id:$id){
                id
                requestedDate
                checkIn
                checkOut
                reason
                lastUpdate
                teamleaderId
                teamApproval
                hrApproval
                status
                lastUpdate
            }
            } `;
    try {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const regularizationRowdata = response.data.data.getRegularizationById;

      setRegularizationData({
        checkIn: regularizationRowdata.checkIn,
        checkOut: regularizationRowdata.checkOut,
        reason: regularizationRowdata.reason,
      });

      setOriginalRegularizationData({
        checkIn: regularizationRowdata.checkIn,
        checkOut: regularizationRowdata.checkOut,
        reason: regularizationRowdata.reason,
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleAddRegularizationDatachange = (event) => {
    // Clone the current state
    let regularizationState = { ...regularizationData };

    // Switch case for handling different input fields
    switch (event.target.name) {
      case "reason": {
        const descriptionRegex = new RegExp("^([\\s\\S]{10,100})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          regularizationState[event.target.name + "Status"] = "success";
        } else {
          regularizationState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "checkIn": {
        // Check for CheckIn value
        if (event.target.value?.trim()) {
          regularizationState[event.target.name + "Status"] = "success";
          regularizationState["checkOut"] = event.target.value;
          // Automatically set the checkOut date to the same date (with time set to 00:00)
          const dateOnly = event.target.value.split("T")[0]; // Extract date part from CheckIn
          // regularizationState.checkOut = dateOnly + "T00:00"; // Set CheckOut to the same date with time 00:00
          // regularizationState.checkOutStatus = "success"; // Update CheckOut status
        } else {
          regularizationState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "checkOut": {
        // Check for CheckOut value
        if (event.target.value?.trim()) {
          regularizationState[event.target.name + "Status"] = "success";
        } else {
          regularizationState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      default:
        break;
    }

    // Update the value of the field being modified
    regularizationState[event.target.name] = event.target.value;

    // Update the state with the modified regularization data
    setRegularizationData(regularizationState);
  };

  const handleAddRegularization = () => {

    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: isAdmin && selectedEmployee
        ? `Are you sure you want to create regularization on behalf of ${selectedEmployee.label}? This will be auto-approved.`
        : "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onRegularizationSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const onDiscardRegularization = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setRegularizationData({
      checkIn: originalRegularizationData.checkIn,
      checkOut: originalRegularizationData.checkOut,
      reason: originalRegularizationData.reason,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      regularizationData.checkInStatus === "success" &&
      regularizationData.checkOutStatus === "success" &&
      regularizationData.reasonStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      regularizationData.checkIn === originalRegularizationData.checkIn &&
      regularizationData.checkOut === originalRegularizationData.checkOut &&
      regularizationData.reason === originalRegularizationData.reason
    ) {
      allowSubmit = false;
    } else if (
      regularizationData.checkIn !== originalRegularizationData.checkIn
    ) {
      if (regularizationData.checkInStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (
      regularizationData.checkOut !== originalRegularizationData.checkOut
    ) {
      if (regularizationData.checkOutStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (
      regularizationData.reason !== originalRegularizationData.reason
    ) {
      if (regularizationData.reasonStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the Regularization details for
                    you. This may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Regularization Details
                      </MaterialTypography>
                    </Stack>
                    {AccessData &&  
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditRegularaization" && item.can_access
                      ) &&
                      pageState.state !== "submitting" && (
                        <ButtonGroup
                        
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                            sx={{
                              "&:hover": {
                                backgroundColor: "none", // Keeps the original background color
                                boxShadow: "none",          // Removes shadow
                              },
                            }}
                          >
                            Edit
                          </MaterialButton>
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Regularization
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}
            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={1}>

                  {/* Employee Selector - only visible for HR/Admin on new requests */}
                  {isAdmin && !id && (
                    <Grid size={{ xs: 6, sm: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Select Employee (On Behalf Of) <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialSelect
                        name="employee"
                        value={selectedEmployee}
                        options={employeeOptions}
                        onChange={(selected) => setSelectedEmployee(selected)}
                        isClearable
                        customStyles={{ optionPadding: 20 }}
                      />
                    </Grid>
                  )}

                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Requested Date
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="requestedDate"
                      value={new Date().toISOString().slice(0, 10)}
                      readOnly
                      error={regularizationData.requesteddatestatus === "error"}
                      success={
                        regularizationData.requesteddatestatus === "success"
                      }
                      disabled={togglePage.view === true ? true : false}
                      
                    />
                  </Grid>

                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        CheckIn <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="checkIn"
                      type="datetime-local"
                      value={regularizationData.checkIn}
                      onChange={handleAddRegularizationDatachange}
                      error={regularizationData.checkInStatus === "error"}
                      success={regularizationData.checkInStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                      inputProps={{
                        min: (() => {
                          // 2-month regularization limit: minimum date is 1st of previous month
                          const now = new Date();
                          const firstOfPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                          return firstOfPrevMonth.toISOString().slice(0, 16);
                        })(),
                      }}
                    />
                  </Grid>

                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        CheckOut <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="checkOut"
                      type="datetime-local"
                      value={regularizationData.checkOut}
                      onChange={handleAddRegularizationDatachange}
                      error={regularizationData.checkOutStatus === "error"} // Update to check for checkout status
                      success={regularizationData.checkOutStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                      inputProps={{
                        min: (() => {
                          // 2-month regularization limit: minimum date is 1st of previous month
                          const now = new Date();
                          const firstOfPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                          return firstOfPrevMonth.toISOString().slice(0, 16);
                        })(),
                      }}
                      // Update to check for checkout status
                    />
                  </Grid>

                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Reason <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="reason"
                      // placeholder="eg. Reason"
                      value={regularizationData.reason}
                      onChange={handleAddRegularizationDatachange}
                      error={regularizationData.reasonStatus === "error"}
                      success={regularizationData.reasonStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                      multiline
                      rows={6}
                    />
                    {regularizationData.reasonStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                        Reason should be a minimum 10 characters maximum 100 characters long.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "submitting" && !pageState.loading && (
              <MaterialBox>
                <MaterialBox
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  minHeight="50vh"
                >
                  <MaterialTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Adding your Regularization data. This should not take much
                    time.
                  </MaterialTypography>
                  <MaterialBox mt={2}>
                    <img src={loading} alt="loading" width="200px" />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={onDiscardRegularization}
                  >
                    Discard
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    // disabled={
                    //     !checkFields() || pageState.state === "submitting"
                    // }
                    onClick={onEditRegularizationSubmit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={
                    !checkAllFields() || pageState.state === "submitting"
                  }
                  onClick={handleAddRegularization}
                >
                  Submit
                </MaterialButton>
              ) : null}
            </MaterialBox>
          )}
          {
            <MaterialSnackbar
              color="success"
              icon={<NotificationsIcon />}
              title="Message"
              content="You have been submitted successfully"
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
        </Card>
      )}
    </DashboardLayout>
  );
};
export default AddRegularization;
